<template>
    <CarouselSlide class="orders-slide">
        <img src="/images/promo/interface-slider/orders-slide.png" alt="Orders interface" />
    </CarouselSlide>
</template>

<script>
import { CarouselSlide } from '@/shared/ui/slider';

export default {
  components: { CarouselSlide },
};
</script>

<style lang="scss" scoped>
.orders-slide {
  border: 1px solid #CADDFC;
  border-radius: 16px;
  overflow: hidden;
}
</style>
